module.exports = __webpack_public_path__ + "@/assets/img/bannerReferido.9ddd139e.gif";